import { j as l } from "./AccesRecoveryIcon-CUPieIxT.js";
const r = () => /* @__PURE__ */ l.jsx("svg", { viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ l.jsx(
  "path",
  {
    d: "M10 20h5l-6.666-6.666L1.667 20h5c0 7.367 5.967 13.334 13.333 13.334 2.617 0 5.05-.767 7.1-2.067l-2.433-2.433A9.8 9.8 0 0 1 20 30c-5.516 0-10-4.483-10-10m2.9-11.266 2.434 2.433A10 10 0 0 1 20 10c5.517 0 10 4.483 10 10h-5l6.667 6.667L38.334 20h-5c0-7.366-5.967-13.333-13.334-13.333-2.616 0-5.05.767-7.1 2.066",
    fill: "currentColor"
  }
) });
export {
  r as S
};
